// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__QysUw","inputWrap":"CustomTip_inputWrap__2vzws"};